import { ApolloClient, HttpLink, InMemoryCache } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";

const getAuthToken = () => {
  return localStorage.getItem("customer_auth_token") || "";
};

export const createApolloClient = (withAuth = false) => {
  const httpLink = new HttpLink({
    uri: process.env.REACT_APP_API_URL,
    credentials: "omit",
  });

  if (!withAuth) {
    return new ApolloClient({
      link: httpLink,
      cache: new InMemoryCache(),
    });
  }

  const authLink = setContext((_, { headers }) => ({
    headers: {
      ...headers,
      "content-type": "application/json",
      authorization: `Bearer ${getAuthToken()}`,
    },
  }));

  return new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache(),
  });
};
